import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { userLogoutAsync } from '../../store/actions/authorize';
import { toggleSidebar } from '../../store/actions/layout';

const Header = () => {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const { isAuthenticated } = useSelector((state) => state.auth);
   const { isSidebarOpened } = useSelector((state) => state.layout);

   const [active, setActive] = useState('');

   const header = useRef();
   const menu = useRef();

   const listItem = [
      {
         title: 'صفحه اصلی',
         link: '/',
         number: '1',
      },
      {
         title: 'درباره ما',
         link: '/aboutUs',
         number: '2',
      },
      {
         title: 'ثبت سفارش',
         link: '/registered',
         number: '3',
      },
      {
         title: 'ثبت فروشگاه',
         link: '/store',
         number: '12',
      },
      {
         title: 'رهگیری مرسوله',
         link: '/tracking',
         number: '4',
      },
      {
         title: 'خدمات',
         link: '/services',
         number: '5',
      },
      {
         title: 'نمایندگی ها',
         link: '/agent',
         number: '6',
      },
      {
         title: 'پشتیبانی',
         link: '/support',
         number: '7',
      },
      {
         title: 'ثبت نظر و شکایات',
         link: '/comments',
         number: '8',
      },
      {
         title: 'فرصت شغلی',
         link: '/job',
         number: '9',
      },
      {
         title: 'ممنوعات ارسال',
         link: '/forbidden',
         number: '10',
      },
      {
         title: 'سوالات متداول',
         link: '/question',
         number: '11',
      },
   ];

   useEffect(() => {
      const headerScroll = () => {
         if (header?.current) header?.current?.classList?.toggle('scroll', window.scrollY > 0);
      };
      window.addEventListener('scroll', headerScroll);
      return () => {
         window.removeEventListener('scroll', headerScroll);
      };
   }, []);

   const handleExit = async () => {
      const res = await dispatch(userLogoutAsync());
      res && navigate('/', { replace: true });
   };

   return (
      <header className='header'>
         <div ref={menu} className={isSidebarOpened ? 'menu active' : 'menu'}>
            <div className='menu__nav'>
               <ul className='menu__list'>
                  {listItem.map((item) => {
                     return (
                        <li
                           key={item.number}
                           className={`menu__item menu__item--${item.number}`}
                           onClick={() => dispatch(toggleSidebar())}
                        >
                           <Link className='menu__link' to={`${item.link}`}>
                              {item.title}
                           </Link>
                        </li>
                     );
                  })}
               </ul>
            </div>
         </div>

         <div className='header__content' ref={header}>
            <div className='header__box'>
               <div
                  className={isSidebarOpened ? 'header__burger active open-menu' : 'header__burger'}
                  id='toggle'
                  onClick={() => dispatch(toggleSidebar())}
               >
                  <div className='header__burger-top'></div>
                  <div className='header__burger-middle'></div>
                  <div className='header__burger-bottum'></div>
               </div>
               <Link className='header__logo-box' to='/'>
                  <img className='header__logo' src='/img/logo.png' alt='logo' />
                  <h4
                     className={
                        isSidebarOpened ? 'header__welcome activeHeader' : 'header__welcome'
                     }
                  >
                     کالاپست
                  </h4>
               </Link>
            </div>
            {isAuthenticated ? (
               <div
                  onMouseEnter={() => setActive('active')}
                  onMouseLeave={() => setActive('')}
                  style={{ display: 'flex', zIndex: '25', position: 'relative' }}
               >
                  <img
                     src='/img/person-svgrepo-com.png'
                     alt=''
                     className={`header__profile ${active}`}
                  />
                  <ul className={`header__list ${active}`}>
                     <li className='header__item'>
                        <Link to='/profile'>حساب کاربری</Link>
                     </li>
                     <li className='header__item' onClick={handleExit}>
                        خروج
                     </li>
                  </ul>
               </div>
            ) : (
               <button className='header__button' onClick={() => navigate('/login')}>
                  <span>
                     <img
                        src='/img/enter.png'
                        alt=''
                        className='header__profile header__profile--login'
                     />
                     ورود | ثبت نام
                     <div className='hoverBtn'></div>
                     <div className='hoverBtn-bottom'></div>
                  </span>
               </button>
            )}
         </div>
      </header>
   );
};

export default Header;
